export default class Content {
  title = ''
  description = ''
  desc_long = ''
  url = ''
  teacher = ''
  remarks = ''
  content_format = ''
  content_type = ''
  user_id = -1
  categoryId?: number
  bookId?: number
  average_rating: number | null = null
  n_ratings?: number
  userRating?: number
  youtube = true
}
